import { FunctionsError, FunctionsHttpError } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';

/**
 * `error.message` do supabase-js pra falhas de Edge Function é sempre o texto
 * genérico "Edge Function returned a non-2xx status code" — o motivo real
 * (o `{ error }` que a function devolveu) só existe no corpo da Response,
 * acessível via `error.context`. `invokeFunction` já resolve isso: lança um
 * `Error` com a mensagem real, então qualquer `catch`/`onError` a jusante
 * mostra algo útil sem precisar saber desse detalhe.
 */
export async function invokeFunction<T>(name: string, options?: { body?: Record<string, unknown> }): Promise<T> {
  const { data, error } = (await supabase.functions.invoke(name, options)) as {
    data: T | null;
    error: FunctionsError | null;
  };
  if (error) {
    if (error instanceof FunctionsHttpError) {
      // `FunctionsError.context` é tipado como `any` na lib — pra HttpError é
      // sempre a Response crua (documentado no supabase-js), daí o cast.
      const context = error.context as Response;
      const body = (await context
        .clone()
        .json()
        .catch(() => null)) as { error?: string } | null;
      if (body?.error) throw new Error(body.error);
    }
    throw error;
  }
  return data as T;
}
